@if (linkVal()) {
  <a
    class="bold-type"
    [href]="linkVal()"
    [ngClass]="{
      'font-body-1 font-body-medium': size() === LinkSize.MEDIUM,
      'font-body-2 font-body-small': size() === LinkSize.SMALL,
      light: theme() === LinkTheme.LIGHT,
      dark: theme() === LinkTheme.DARK,
      disabled: disabled(),
      truncate: truncate(),
      'new-brand': isNewBrand(),
    }"
    [attr.rel]="rel()"
    [attr.target]="target()"
    [attr.aria-label]="aria()?.label"
    [attr.aria-describedby]="aria()?.describedby"
    [attr.aria-controls]="aria()?.controls"
    [attr.aria-disabled]="disabled() || aria()?.disabled"
    [attr.aria-selected]="aria()?.selected"
    (click)="handleClick($event)"
  >
    <ng-container *ngTemplateOutlet="linkText" />
  </a>
}
@if (!linkVal()) {
  <button
    class="underline bold-type"
    [ngClass]="{
      'font-body-1 font-body-medium': size() === LinkSize.MEDIUM,
      'font-body-2 font-body-small': size() === LinkSize.SMALL,
      light: theme() === LinkTheme.LIGHT,
      dark: theme() === LinkTheme.DARK,
      disabled: disabled(),
      truncate: truncate(),
      'new-brand': isNewBrand(),
    }"
    [attr.aria-label]="aria()?.label"
    [attr.aria-describedby]="aria()?.describedby"
    [attr.aria-controls]="aria()?.controls"
    [attr.aria-disabled]="disabled() || aria()?.disabled"
    [attr.aria-selected]="aria()?.selected"
    (click)="handleClick($event)"
  >
    <ng-container *ngTemplateOutlet="linkText" />
  </button>
}

<ng-template #linkText>
  @if (effectiveIcon()?.position === IconPosition.LEFT) {
    <ng-container *ngTemplateOutlet="iconContainer" />
  }

  <ng-content />

  @if (effectiveIcon()?.position === IconPosition.RIGHT) {
    <ng-container *ngTemplateOutlet="iconContainer" />
  }
</ng-template>

<ng-template #iconContainer>
  <fcom-icon [category]="effectiveIcon().category" [name]="effectiveIcon().name" [ngClass]="iconClasses()" />
</ng-template>
